import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlertAqi = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M36.25 43.75C36.25 47.875 32.875 51.25 28.75 51.25C24.625 51.25 21.25 47.875 21.25 43.75H26.25C26.25 45.125 27.375 46.25 28.75 46.25C30.125 46.25 31.25 45.125 31.25 43.75C31.25 42.375 30.125 41.25 28.75 41.25H5V36.25H28.75C32.875 36.25 36.25 39.625 36.25 43.75ZM47.5 17.5C47.5 12.675 43.575 8.75 38.75 8.75C33.925 8.75 30 12.675 30 17.5H35C35 15.425 36.675 13.75 38.75 13.75C40.825 13.75 42.5 15.425 42.5 17.5C42.5 19.575 40.825 21.25 38.75 21.25H5V26.25H38.75C43.575 26.25 47.5 22.325 47.5 17.5ZM46.25 28.75H5V33.75H46.25C48.325 33.75 50 35.425 50 37.5C50 39.575 48.325 41.25 46.25 41.25V46.25C51.075 46.25 55 42.325 55 37.5C55 32.675 51.075 28.75 46.25 28.75Z",
		fill: "#FBC02D"
	})
});
export default SvgAlertAqi;
